// extracted by mini-css-extract-plugin
module.exports = {"container":"Questions_container__R1t2C"};